// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__12PND","infoText":"styles_infoText__38nt-","button":"styles_button__2PDN1"};